if (!customElements.get('full-width-image-slider')) {
  class FullWidthImageSlider extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splide = null;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.bindFullscreenButtons();
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSlider();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSlider();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSlider() {
      const slider = this.querySelector('[data-full-width-image-slider]');
      if (!slider || slider.dataset.sliderMounted === 'true') return;

      const totalSlides = slider.querySelectorAll('.splide__slide').length;
      if (!totalSlides) return;

      const showControls = totalSlides > 1;

      slider.dataset.sliderMounted = 'true';

      const splide = new Splide(slider, {
        type: 'slide',
        arrows: showControls,
        pagination: showControls,
        drag: showControls,
        rewind: showControls,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        gap: 0,
        perMove: 1,
        flickMaxPages: 1,
        updateOnMove: true,
        perPage: 1,
        padding: {
          left: '0px',
          right: '0px',
        },
        classes: {
          arrows: 'splide__arrows full-width-image-slider__arrows',
          arrow: 'splide__arrow full-width-image-slider__arrow',
          prev: 'splide__arrow--prev full-width-image-slider__arrow full-width-image-slider__arrow--prev',
          next: 'splide__arrow--next full-width-image-slider__arrow full-width-image-slider__arrow--next',
          pagination: 'splide__pagination full-width-image-slider__pagination',
          page: 'splide__pagination__page full-width-image-slider__pagination-dot',
        },
      });

      if (showControls) {
        splide.on('arrows:mounted', (prev, next) => {
          const arrowIcon = `
            <span class="full-width-image-slider__arrow-icon" aria-hidden="true">
              <svg viewBox="0 0 27 17" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.667 9.81849L26.6672 7.15196H5.10467L10.3709 1.88561L8.48534 0L0 8.48529L8.48534 16.9706L10.3709 15.0849L5.10453 9.81863L26.667 9.81849Z" />
              </svg>
            </span>
          `;

          if (prev) {
            prev.innerHTML = arrowIcon;
            prev.setAttribute('aria-label', 'Previous slide');
          }

          if (next) {
            next.innerHTML = arrowIcon;
            next.setAttribute('aria-label', 'Next slide');
          }
        });

        splide.on('pagination:mounted', (data) => {
          data.items.forEach((item, index) => {
            item.button.innerHTML = `
              <span class="full-width-image-slider__pagination-icon" aria-hidden="true">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="white"/>
                </svg>
              </span>
            `;
            item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
          });
        });
      }

      splide.mount();
      this.splide = splide;
    }

    bindFullscreenButtons() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-full-width-image-slider-fullscreen]');
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const src = button.dataset.fullscreenSrc;
        if (!src) return;

        const alt = button.dataset.fullscreenAlt || '';
        const viewer = document.createElement('div');
        const image = document.createElement('img');
        const closeButton = document.createElement('button');

        viewer.className = 'full-width-image-slider__fullscreen-viewer';
        viewer.setAttribute('role', 'dialog');
        viewer.setAttribute('aria-modal', 'true');
        viewer.setAttribute('aria-label', 'Fullscreen image');
        image.src = src;
        image.alt = alt;
        closeButton.className = 'full-width-image-slider__fullscreen-close';
        closeButton.type = 'button';
        closeButton.setAttribute('aria-label', 'Close fullscreen image');
        closeButton.innerHTML = `
          <svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">
            <path d="M1.8 0.8 6 5l4.2-4.2 1 1L7 6l4.2 4.2-1 1L6 7l-4.2 4.2-1-1L5 6 .8 1.8l1-1Z" />
          </svg>
        `;
        viewer.appendChild(image);
        viewer.appendChild(closeButton);
        document.body.appendChild(viewer);

        const closeViewer = () => {
          document.removeEventListener('keydown', handleKeydown);
          document.removeEventListener('fullscreenchange', handleFullscreenChange);

          if (document.fullscreenElement === viewer && document.exitFullscreen) {
            document.exitFullscreen().catch(() => {});
          }

          if (viewer.parentNode) {
            viewer.parentNode.removeChild(viewer);
          }
        };

        const handleKeydown = (event) => {
          if (event.key === 'Escape') closeViewer();
        };

        const handleFullscreenChange = () => {
          if (!document.fullscreenElement && viewer.parentNode) {
            closeViewer();
          }
        };

        viewer.addEventListener('click', closeViewer);

        document.addEventListener('keydown', handleKeydown);
        document.addEventListener('fullscreenchange', handleFullscreenChange);

        if (viewer.requestFullscreen) {
          viewer.requestFullscreen().catch(() => {
            viewer.classList.add('is-fallback');
          });
        } else {
          viewer.classList.add('is-fallback');
        }
      });
    }
  }

  customElements.define('full-width-image-slider', FullWidthImageSlider);
}
